import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-label": "Page navigation example",
  class: "mt-4"
}
const _hoisted_2 = { class: "pagination justify-content-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  fill: "currentColor",
  class: "bi bi-arrow-left-short",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "page-item" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-arrow-right-short",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.pagination.totalPages > 1)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", {'disabled': _ctx.pagination.page <= 1}])
          }, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.move(-1)), ["prevent"])),
              class: "page-link",
              href: "#",
              "aria-label": "Previous"
            }, _hoisted_4)
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pgLoops, (i) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_5, [
              (i > 0 && i <= _ctx.pagination.totalPages)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      class: _normalizeClass(["page-link", { 'active': i === _ctx.pagination.page }]),
                      to: { name: _ctx.routeName, params: { page: i } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(i), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "to"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 256)),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", {'disabled': _ctx.pagination.page >= _ctx.pagination.totalPages}])
          }, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.move(1)), ["prevent"])),
              class: "page-link",
              href: "#",
              "aria-label": "Next"
            }, _hoisted_8)
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}